import { Suspense, lazy, useEffect, useState } from 'react';
import AppProvider, { useApp } from './contexts/appContext';
import './App.css';
const BrowserIphone = lazy(() => import('./components/browserIphone'));
const BrowserFirefox = lazy(() => import('./components/browserFirefox'));
const MainContent = lazy(() => import('./AppWrapper'));


const isIOS = typeof navigator.standalone === 'boolean';

function App() {
    return (
        <AppProvider>
            <Temp />
        </AppProvider>
    );;
}

function Root() {

    const { user, reload } = useApp();

    const [loadStage, setLoadStage] = useState(0);

    useEffect(() => {
        setLoadStage(0);
        setTimeout(() => setLoadStage(1), 300);
        //   setTimeout(()=>setLoadStage(2), 2500);
    }, [user])

    return (
        <div className="App">
            <Suspense>
                {isIOS ? <BrowserIphone/> : <BrowserFirefox key={user} />}
            </Suspense>
            {/* {((reload && loadStage > 0) || !reload) && <Suspense> */}
            {((loadStage > 0)) && <Suspense>
                <MainContent/>
            </Suspense>}
        </div>
    )
}

function Temp() {
    const { user } = useApp();
    return (
        <Root key={user}/>
    )
}

export default App;